module.exports = __webpack_public_path__ + "img/boton_herramienta.f619d3d8.svg";